export const getServerErrorMessage = (error: any): string => {
  if (error === null || error === undefined) return '';

  if (error?.response?.data?.errors !== undefined && error?.request?.status === 422) {
    const message = error.response.data.errors.map((err: { message: any; }) => err.message)
    return message.join(' \n');
  }

  if (error?.response?.data?.errorMessage !== undefined) return error.response.data.errorMessage;
  if (error?.response?.data?.message !== undefined) return error.response.data.message;
  if (error?.response?.data?.errors !== undefined) {
    if(error?.response?.data?.errors === null){
      return error?.response?.data?.title
    }
    const message = Object.keys(error.response.data.errors).map((key) => {
      return error.response.data.errors[key].join(' \n');
    });
    return message.join(' \n');
  }
  if (error?.errorMessage !== undefined) return error.errorMessage;
  if (error.message !== undefined) return error.message;
  if (error?.request?.status === 500) {
    return error;
  } else if (error?.request?.status === 404) {
    return 'Ups, problem sa serverom';
  } else {
    return 'Greska!';
  }
};
